import {Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { PagesService } from '../pages.service';
import { Store } from '../../store';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {

    user$ = this.store.select<any>('user');

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    params = {
        searchTerm: '',
        limit: 50,
        limits: [20, 50, 75, 100],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'cms_pages.name ASC',
        sorts: [
            { ID: 'cms_pages.created DESC', name: 'Recent First' },
            { ID: 'cms_pages.created ASC', name: 'Recent Last' },
            { ID: 'cms_pages.name ASC', name: 'Page name A-Z' },
            { ID: 'cms_pages.name DESC', name: 'Page name Z-A' },
        ]
    };

    pages = [];
    showConfirmation = false;
    pageToDelete;

    constructor(
        private pagesService: PagesService,
        private router: Router,
        private store: Store,
        private toastrService: ToastrService,
    ) {
        this.getPages();
    }

    ngOnInit() {
    }

    getPages() {
        this.pagesService.getPages(this.params).subscribe(data => {
            this.pages = data.data;
        });
    }

    createPage() {
        this.router.navigate(['cms', 'pages', 'new']);
    }

    updatePage(page) {
        this.router.navigate(['cms', 'pages', page.route]);
    }

    setStatus(page) {
        if (page.active === 1) {
            page.active = 0;
        } else {
            page.active = 1;
        }
        this.pagesService.updatePage(page).subscribe();
    }
    setQL(page, type) {
        if (page[type] === 1) {
            page[type] = 0;
        } else {
            page[type] = 1;
        }
        this.pagesService.updatePage(page).subscribe();
    }
    setExternal(page) {
        if (page.external === 1) {
            page.external = 0;
        } else {
            page.external = 1;
        }
        this.pagesService.updatePage(page).subscribe();
    }
    isOdd(num) {
        if (num % 2 === 1) {
            return false;
        } else {
            return true;
        }
    }


    deleteConfirm(page) {
        this.confirmationData.title = 'Please confirm you would like to delete this page';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
        this.pageToDelete = page;
    }
    confirmAction(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.pagesService.delete(this.pageToDelete).subscribe(data => {
                this.toastrService.success('Page deleted');
                this.getPages();
            });
        }
        this.confirmationData.open = false;
    }

}
